export default __webpack_public_path__ + "static/media/skills.39f4f30b.png";